/**
 * External Imports
 */
import {
  FC,
  useEffect,
  // useRef,
  useState
} from 'react';
import { connect } from 'react-redux';
import { format, isMatch, parse } from 'date-fns';

/**
 * Nexus Imports
 */
// import { NeuFeedback } from '@neutron/react';

/**
 * Internal Imports
 */
import ReusableTabs from '../../reusableTabs';

import { useGetEmployeeByIdQuery } from '../../../redux/apis/Employees.api';

import { useUserRolesRef } from '../../../services/UserRoles/userRoles';
// import { handleBlobPicUrl, userProfilePicUrl } from '../../../utils/helpers';

import { RootState } from '../../../redux/store';
// import { usePostUpdateUserProfilePicMutation } from '../../../redux/apis/Users.api';

/**
 * Style Imports
 */
import {
  AccountHeader,
  AccountInfoContainer,
  // Avatar,
  HeaderTitle,
  SubToolbar,
  UserInfo
} from './SubNavAccount.styles';
// import { EmployeeAvatar } from '../../customTables/employees/employeeListTable/EmployeeListTable.styles';

/**
 * Global Type Definition Imports
 */
import { AuthUserProps } from '../../../config/interfaces';

/**
 * Static File Imports
 */
// import defaultImage from '../../../assets/images/defaultImage.png';

interface ISubNavAccountProps {
  // userImageUrl?: string;
  authorizedUser?: AuthUserProps;
  // sasToken: string;
}

const SubNavAccount: FC<ISubNavAccountProps> = ({
  // userImageUrl = '',
  authorizedUser
  // sasToken,
}) => {
  const [anniversary, setAnniversary] = useState<string>('');
  const [effectiveStartDate, setEffectiveStartDate] = useState<string>('');
  // const photoFileInputEl = useRef<HTMLInputElement>(null);

  const {
    isEmployeeRounder,
    isCSCRounder,
    isCNEdRounder,
    isValidationRounder,
    isAidetValidationRounder,
    isBssrValidationRounder,
    isNonSupportRounder,
    isSupportRounder,
    isTemplateConfigurator,
    isUserAdmin
  } = useUserRolesRef();

  const {
    data: employeeByIdData = []
    // isError: isGetEmployeeByIdError,
    // isFetching: isGetEmployeeByIdFetching
    // isLoading: isGetEmployeeByIdLoading
  } = useGetEmployeeByIdQuery(authorizedUser?.hcaid ?? '', {
    refetchOnMountOrArgChange: 600,
    skip: !authorizedUser?.hcaid
  });

  const reusableTabItems = {
    base: '/account',
    links: [
      // TODO removed until notifications are managed in orbit
      // { label: 'Notifications', path: '/notifications' },
      ...(isNonSupportRounder || isTemplateConfigurator || isUserAdmin
        ? [
            {
              label: 'Facility and Unit Settings',
              path: '/facility-and-unit-settings'
            }
          ]
        : []),
      ...(isEmployeeRounder ||
      isSupportRounder ||
      isValidationRounder ||
      isAidetValidationRounder ||
      isBssrValidationRounder
        ? [
            {
              label: 'Employee Rounding Settings',
              path: isEmployeeRounder
                ? '/employee-rounding-settings'
                : isCSCRounder
                ? '/employee-rounding-settings/csc-list'
                : isCNEdRounder
                ? '/employee-rounding-settings/cned-list'
                : isAidetValidationRounder
                ? '/employee-rounding-settings/aidet-validation-list'
                : isBssrValidationRounder
                ? '/employee-rounding-settings/bssr-validation-list'
                : '/employee-rounding-settings/nlr-validation-list'
            }
          ]
        : [])
    ]
  };

  // const [
  //   postUpdateUserProfilePic,
  //   {
  //     isError: ispPostUpdateUserProfilePicError,
  //     isLoading: isPostUpdateUserProfilePicLoading,
  //     isSuccess: isPostUpdateUserProfilePicSuccess
  //   }
  // ] = usePostUpdateUserProfilePicMutation();

  useEffect(() => {
    if (employeeByIdData) {
      if (
        employeeByIdData.effectiveStartDate &&
        employeeByIdData.effectiveStartDate !== 'NULL'
      ) {
        setEffectiveStartDate(
          !isMatch(employeeByIdData.effectiveStartDate, 'MM/dd/yyyy')
            ? format(
                parse(
                  employeeByIdData.effectiveStartDate,
                  'yyyyMMdd',
                  new Date()
                ),
                'MM/dd/yyyy'
              )
            : employeeByIdData.effectiveStartDate
        );
      } else if (employeeByIdData.startDate) {
        setEffectiveStartDate(employeeByIdData.startDate);
      } else setEffectiveStartDate('N/A');

      if (employeeByIdData.annivDate) {
        setAnniversary(employeeByIdData.annivDate);
      } else {
        setAnniversary('N/A');
      }
    }
  }, [employeeByIdData]);

  // const handleFileUpload = async (e: React.BaseSyntheticEvent<MouseEvent>) => {
  //   const ext = e.target.files[0].name.match(/\.([^.]+)$/)[1].toLowerCase();
  //   switch (ext) {
  //     case 'jpg':
  //     case 'bmp':
  //     case 'png':
  //     case 'tif':
  //     case 'gif':
  //     case 'tiff':
  //     case 'jpeg':
  //     case 'raw':
  //       postUpdateUserProfilePic({
  //         hcaid: authorizedUser?.hcaid,
  //         pic: e.target.files[0]
  //       });
  //       // appInsights.trackEvent({
  //       //   name: 'Picture_Upload_Successful'
  //       // });
  //       break;
  //     default:
  //     // toast('This format is not allowed!', 'error', null, 500, true);
  //     // appInsights.trackEvent({
  //     //   name: 'Picture_Upload_Failed'
  //     // });
  //   }
  // };

  // const handleFileSubmit = (e: React.BaseSyntheticEvent<MouseEvent>) => {
  //   e.preventDefault();
  //   handleFileUpload(e);
  // };

  return (
    <SubToolbar id="SubNav-Account">
      <AccountHeader>MY ACCOUNT</AccountHeader>
      <AccountInfoContainer>
        <HeaderTitle className="d-flex">
          {/* <Avatar
            id="SubNav-Account-User-Image"
            className="neu-text-gray-90"
            style={{ height: '40px', width: '40px' }}
          >
            {!isPostUpdateUserProfilePicLoading ? (
              sasToken && userImageUrl ? (
                <EmployeeAvatar
                  src={
                    handleBlobPicUrl(userImageUrl, sasToken) ??
                    userProfilePicUrl(
                      authorizedUser?.hcaid || 'default',
                      sasToken
                    )
                  }
                  alt="User"
                  onError={e => {
                    e.currentTarget.src = defaultImage;
                    return null;
                  }}
                />
              ) : (
                <EmployeeAvatar src={defaultImage} alt="Default Image" />
              )
            ) : (
              <NeuFeedback
                kind="brand"
                color="orange"
                label="Loading"
                text="Loading..."
                size="small"
              />
            )}
          </Avatar> */}
          <HeaderTitle id="SubNav-Account-Name-34">
            Name & 3-4 ID
            <UserInfo>
              {`${authorizedUser?.firstName ? authorizedUser.firstName : ''} ${
                authorizedUser?.lastName ? authorizedUser.lastName : ''
              } | ${authorizedUser?.hcaid ? authorizedUser.hcaid : ''}`}
            </UserInfo>
          </HeaderTitle>
        </HeaderTitle>
        <HeaderTitle id="SubNav-Account-Email">
          Email
          <UserInfo>
            {`${authorizedUser?.email ? authorizedUser.email : ''}`}
          </UserInfo>
        </HeaderTitle>
        <HeaderTitle id="SubNav-Account-Dep-Start">
          Dept Start Date
          <UserInfo>{`${effectiveStartDate}`}</UserInfo>
        </HeaderTitle>
        <HeaderTitle id="SubNav-Account-Anniversary">
          Anniversary
          <UserInfo>{`${anniversary}`}</UserInfo>
        </HeaderTitle>
      </AccountInfoContainer>
      {/* TODO: Possibly put back in later once GHR pics are ingested */}
      {/* <EditContainer>
        <input
          type="file"
          onChange={(e: React.BaseSyntheticEvent<MouseEvent>) => {
            handleFileSubmit(e);
          }}
          ref={photoFileInputEl}
          hidden
        />
        <EditButton
          type="button"
          onClick={() => photoFileInputEl.current!.click()}
        >
          Edit
        </EditButton>
      </EditContainer> */}
      <ReusableTabs tabItems={reusableTabItems} justify="end" />
    </SubToolbar>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  authorizedUser: state.AuthorizedUser.authorizedUser,
  userImageUrl: state.AuthorizedUser.authorizedUser.pictureUrl
  // sasToken: state.ConfigReducer.sasToken
});

export default connect(mapReduxStateToProps)(SubNavAccount);
